import GeneralAddPage from './general-add-page';

export default GeneralAddPage;